import { detectBreakpoints } from "../detectBreakpoints";
import { useChatRoomContext } from "./useChatRoomContext";

export const calculateScrollInfo = ({
  event,
  scrollerId = "message-scroll-view",
}: {
  event: string;
  scrollerId?: string;
}) => {
  const { isMobileView } = detectBreakpoints();

  const element = document.getElementById(scrollerId);
  if (!element) return {};

  let action = "noScroll";

  switch (event) {
    case "messageSent":
      action = "scrollToBottom";
      break;
    case "messageReceived": {
      const distanceFromBottom =
        element.scrollTop - element.scrollHeight + element.offsetHeight;

      const isMobileBottom = isMobileView() && distanceFromBottom === 0;
      const isBottomRange =
        distanceFromBottom >= -(element.offsetHeight * 0.8) ||
        distanceFromBottom > 14;

      if (isMobileBottom || isBottomRange) action = "scrollToBottom";
      break;
    }
    case "chatRoomLoad":
      action = "scrollToUnreadMessageIndicator";
      break;
    case "paginatedMessageLoad":
      action = "adjustTop";
      break;
    case "nextPaginatedMessageLoad":
      action = "noScroll";
      break;
    case "messageUpdated":
      action = "noScroll";
      break;
    case "messageDeleted":
      action = "noScroll";
      break;
    case "parentMessageUpdated":
      action = "noScroll";
      break;
    case "reaction": {
      const distanceFromBottom =
        element.scrollTop - element.scrollHeight + element.offsetHeight;
      const isCloseToTheBottom = distanceFromBottom >= -80;
      if (isCloseToTheBottom) action = "scrollToBottom";
      break;
    }
  }
  return {
    action: action,
    scrollTopValue: element.scrollTop,
    scrollHeightValue: element.scrollHeight,
  };
};

export const getScrollerId = (isMessaging: boolean, chatRoomUuid: string) =>
  isMessaging && chatRoomUuid
    ? `message-scroll-view-${chatRoomUuid}`
    : "message-scroll-view";

export const useScrollInfo = () => {
  const { chatRoomUuid, isMessaging } = useChatRoomContext();
  const scrollerId = getScrollerId(isMessaging, chatRoomUuid);

  const getScrollingElement = () => document.getElementById(scrollerId);

  const calculateScrollInfoWithScrollerId = ({ event }: { event: string }) =>
    calculateScrollInfo({ event, scrollerId });

  return {
    calculateScrollInfo: calculateScrollInfoWithScrollerId,
    scrollerId,
    getScrollingElement,
  };
};
